import { render, staticRenderFns } from "./ContentBodyCard.vue?vue&type=template&id=8b13f830&scoped=true"
import script from "./ContentBodyCard.vue?vue&type=script&lang=js"
export * from "./ContentBodyCard.vue?vue&type=script&lang=js"
import style0 from "./ContentBodyCard.vue?vue&type=style&index=0&id=8b13f830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b13f830",
  null
  
)

export default component.exports